// OrgMembershipManagement.js
import React, { useState } from 'react';
import { ButtonGroup, IconButton, Typography } from '@mui/material';

import MembershipList from '../components/membership/MembershipList';
import MembershipInfo from '../components/membership/MembershipInfo';
import { Add, ContactMail } from '@mui/icons-material';

import './OrgMembershipManagement.css';
import '../../b2b-common/B2BButtonGroup.css'
import { withAutoFocus } from '../../b2b-common/helpers';

const OrgMembershipManagement = ({ organization, onUpdatedOrgMembership }) => {
    const [selectedMember, setSelectedMember] = useState(null);
    const [isNewMember, setIsNewMember] = useState(false);
    const [isNewMemberByEmail, setIsNewMemberByEmail] = useState(false);
    const AutoFocusMembershipInfo = withAutoFocus(MembershipInfo);

    const handleSelectMember = (member, newMember = false, newMemberByEmail = false) => {
        setSelectedMember(member);
        setIsNewMember(newMember);
        setIsNewMemberByEmail(newMemberByEmail);
    };

    const handleSelectMemberClose = () => {
        setSelectedMember(null);
        setIsNewMember(false);
    };

    const handleMemberUpdate = (updatedMember) => {
        const existingMember = organization.organizationMembers.find((member) => member.userId === updatedMember.userId);
        if (existingMember) {
            const updatedMembers = organization.organizationMembers.map((member) =>
                member.userId === updatedMember.userId ? updatedMember : member
            );
            onUpdatedOrgMembership(updatedMembers);
        } else {
            const updatedMembers = [...organization.organizationMembers, updatedMember];
            onUpdatedOrgMembership(updatedMembers);
        }
    };

    const handleMemberRemoved = (removedMember) => {
        const existingMember = organization.organizationMembers.find((member) => member.userId === removedMember.userId);
        if (existingMember) {
            const updatedMembers = organization.organizationMembers.filter((member) => member.userId !== removedMember.userId);
            onUpdatedOrgMembership(updatedMembers);
        }
    };

    const membershipButtons = [
        <IconButton
            key="new"
            onClick={() => handleSelectMember(getNewMemberObject(), true, false)}
            className="MembershipManagement-button"
        >
            <Add />
            <Typography variant="body2">New Member</Typography>
        </IconButton>,
        <IconButton
            key="invite"
            onClick={() => handleSelectMember(getNewMemberObject(), false, true)}
            className='MembershipManagement-button'
        >
            <ContactMail />
            <Typography variant="body2">Invite Member</Typography>
        </IconButton>
    ];

    return (
        <div className="MembershipManagement">
            <MembershipList members={organization.organizationMembers} onSelectMember={handleSelectMember} />
            <ButtonGroup size="small" aria-label="small button group" className="b2b-default-button-group">
                {membershipButtons}
            </ButtonGroup>
            {(selectedMember || isNewMember) && (
                <AutoFocusMembershipInfo
                    initialMember={isNewMember ? getNewMemberObject() : selectedMember}
                    isNewMember={isNewMember}
                    isNewMemberByEmail={isNewMemberByEmail}
                    onMemberUpdate={handleMemberUpdate}
                    onMemberRemove={handleMemberRemoved}
                    onClose={handleSelectMemberClose}
                />
            )}
        </div>
    );
};

const getNewMemberObject = () => {
    return {
        user: {
            email: '',
            firstName: '',
            lastName: '',
            password: '',
            locale: 'es',
        },
        roles: [],
        enabled: true,
    };
};

export default OrgMembershipManagement;